import request from '@/utils/request'


// 查询菜单列表
export function listDept(para) {
  return request({
    url: '/system/dept/list',
    method: 'post',
    data: para
  })
}
// 增加
export function addDept(para) {
  return request({
    url: '/system/dept/add',
    method: 'post',
    data: para
  })
}
export function updateDept(para) {
  return request({
    url: '/system/dept/edit',
    method: 'post',
    data: para
  })
}
export function getDept(deptId) {
  return request({
    url: '/system/dept/detail/'+deptId,
    method: 'get',
  })
}
export function delDept(deptId) {
  return request({
    url: '/system/dept/remove/'+deptId,
    method: 'get',
  })
}

export function listDeptExcludeChild(deptId){
  return request({
    url: '/system/dept/excludeChildList/'+deptId,
    method: 'get',
  })
}
